import PropTypes from 'prop-types';
var notificationCenterItemProps = {
  action: PropTypes.element,
  appearance: PropTypes.oneOf(['notification', 'section']),
  avatar: PropTypes.element,
  content: PropTypes.string,
  icon: PropTypes.element,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onClickItem: PropTypes.func,
  read: PropTypes.bool,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['help', 'informative', 'negative', 'positive', 'warning'])
};
var notificationCenterItemDefaultProps = {
  action: undefined,
  appearance: 'notification',
  avatar: undefined,
  content: undefined,
  icon: undefined,
  onClickItem: undefined,
  read: false,
  type: undefined
};
export { notificationCenterItemDefaultProps, notificationCenterItemProps };